import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ApiService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';
import { MatDialog } from '@angular/material';
import { ConfirmationComponent } from '@angular/synthrone-design/components';
import { AddUpdateFontVariantComponent } from '@synthroneApp/components/forms/add-update-font-variant/add-update-font-variant.component';

@Component({
  selector: 'app-organization-font-variants-view',
  templateUrl: './organization-font-variants-view.component.html',
  styleUrls: ['./organization-font-variants-view.component.scss']
})
export class OrganizationFontVariantsViewComponent implements OnInit {

	@ViewChild('fontVariantsTable') fontVariantsTable;

	configColumns = {
		name: {
		  label: 'Name',
		  sortable: false,
		  truncate: false
		},
		weight: {
		  label: 'Weight',
		  sortable: false,
		  truncate: false
		},
		style: {
		  label: 'Style',
		  sortable: false,
		  truncate: false
		},
		fontUrl: {
		  label: 'S3 Key',
		  sortable: false,
		  truncate: false
		}
	};

	data: any = {
        row: {
            id: ''
        },
        client: ''
    }

  constructor(
	protected api: ApiService, 
    @Inject(APP_CONFIG) private config, 
    protected dialog: MatDialog
  	) { }

  ngOnInit() {
  }

  sdVariants = (limit, offset, sortBy, sortOrder): Observable<any> => {
      return this.api.makeRequest('api_system_fonts_details', {
          id: this.data.row.id,
          client: this.data.client
      }, 'crafter').flatMap((result: any) => {
      	let returnData = {
      		currentOffset: 0,
      		data: result['variants'],
      		total: result['variants'].length
      	};

      	return Observable.of(returnData);
      });
  }

  refreshTable = () => {
    this.fontVariantsTable.getData()
  };

  deleteRow = (row) => {
    let dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        message: `Are you sure you want to remove the <b>${row.name}</b> font variant? <br>Removal is irreversible.`
      }
    }).afterClosed().subscribe((response) => {
      if (response == "proceed") {
        const params: any = {
            id: row.id,
        };
        this.api.makeRequest('api_system_fonts_variant_delete', params, 'crafter').subscribe(() => {
          this.refreshTable();
        });
      }
    });
  };

  addFontVariant = () => {
  this.dialog.open(AddUpdateFontVariantComponent, {
    height: '600px',
    width: '800px',
    data: {
        oldName: '',
        callback: (params: any) => {
            return this.api.makeRequest('api_system_fonts_variant_create', Object.assign(params, {'id': this.data.row.id }), 'crafter');
        }
    },
    panelClass: 'no-padding-container'
    }).afterClosed().subscribe((response) => {
        if (response === true) {
            this.refreshTable();
        }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/views/organization-font-variants-view/organization-font-variants-view.component.ts